import './styles.scss';

export const Footer = () => {
    return (
        <div className='footer'>
            <h2>Desenvolvido por: Lucas Hylario</h2>
        </div>
    )
}